import { CommonModule } from '@angular/common';
import { appleApplicationReducer } from './apple-applications.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppleApplicationEffects } from './apple-applications.effects';
import { NgModule } from '@angular/core';
import { UploadService } from './upload.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('apple-applications', appleApplicationReducer),
    EffectsModule.forFeature([AppleApplicationEffects]),
  ],
  providers: [UploadService],
})
export class AppleApplicationStoreModule {}
